import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useDemoData } from '@mui/x-data-grid-generator';

const OutsourcingPage = () => {
  const { data, loading } = useDemoData({
    dataSet: 'Employee',
    rowLength: 1000,
    treeData: { maxDepth: 2, groupingField: 'name', averageChildren: 200 },
  });
  
  return (
    <div style={{ backgroundColor: 'white', width: '100%' }}>
    <div style={{ height: 400, width: '100%' }}>
      <DataGridPro loading={loading} {...data} />
    </div>
    </div>
  );
};

export default OutsourcingPage;